var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarterPlanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.338013,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#FEEFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5855 23.75V26.25C46.5855 38.2843 39.8699 43.75 31.5856 43.75L29.2085 43.7499C29.4729 39.9845 30.6448 37.706 33.7054 34.9986C35.2104 33.6673 35.0836 32.8986 34.3416 33.3401C29.2371 36.377 26.7019 40.4827 26.5895 47.0378L26.5856 47.5H24.0856C24.0856 45.7966 24.2302 44.2496 24.5178 42.8353C24.2296 41.2176 24.0856 39.022 24.0856 36.25C24.0856 29.3464 29.682 23.75 36.5855 23.75C39.0855 23.75 41.5855 25 46.5855 23.75Z",
    fill: "#F9AD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterPlanV2);
export default __webpack_public_path__ + "static/media/starter_plan_v2.08bbced5dc4fb5c6aefdc9d190dc3d7a.svg";
export { ForwardRef as ReactComponent };